import React from "react";
import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";

const SidebarItem = ({
  item,
  isHovered,
  isActive,
  onHover,
  onClick,
}) => {
  const location = useLocation();
  return (
    <li
      className={`sidebar-singleitem ${isActive ? "active" : ""}`}
      onMouseEnter={() => onHover(item.name)}
      onMouseLeave={() => onHover(null)}
      onClick={onClick} // Ensure the click event is handled here
    >
      <Link to={item.to} className="item-container item-content">
        <Icon icon={item.icon} className="icon" />
        <span className="item-name">{item.name}</span>
        {item.notifications > 0 && (
          <span className="badge">{item.notifications}</span>
        )}
      </Link>

      {item.submenu?.length > 0 && (
        <ul className="submenu">
          {item.submenu.map((submenuItem) => (
            <li key={submenuItem.name} className={`submenu-item ${location.pathname === submenuItem.to ? "active" : ""}`}>
              <Link to={submenuItem.to} className="submenu-item-content">
                <span className="item-name">{submenuItem.name}</span>
              </Link>

              {submenuItem.submenu && (
                <ul className="subsubmenu">
                  {submenuItem.submenu.map((subsubmenuItem) => (
                    <li key={subsubmenuItem.name} className="subsubmenu-item">
                      <Link to={subsubmenuItem.to}>{subsubmenuItem.name}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default SidebarItem;
